import { Outlet, useNavigate } from 'react-router-dom';
import { LogOut, Settings } from 'lucide-react';
import { useBrandingStore } from '@shared/stores/brandingStore';
import { useAuthStore } from '@shared/stores/authStore';
import { effectiveGuardAuthMode } from '@shared/lib/guardAuth';
import { env } from '@config/env';

export function NocLayout(): JSX.Element {
  const navigate = useNavigate();
  const branding = useBrandingStore((s) => s.branding);
  const authMethod = useAuthStore((s) => s.authMethod);
  const user = useAuthStore((s) => s.user);

  const title = branding?.name ?? env.appName;
  const subtitle =
    authMethod === 'api_key'
      ? 'API key · kiosk'
      : user?.email
        ? user.email
        : 'Staff session';

  return (
    <div className="flex min-h-screen flex-col bg-white text-ink">
      <header className="safe-top flex shrink-0 items-center justify-between gap-3 border-b border-neutral-200 px-4 py-3">
        <div className="min-w-0">
          <p className="truncate text-lg font-semibold tracking-tight">{title}</p>
          <p className="truncate text-xs text-neutral-500">Guard NOC · {subtitle}</p>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          {effectiveGuardAuthMode() !== 'user' && (
            <button
              type="button"
              aria-label="Provision"
              className="rounded p-2 text-neutral-600 hover:bg-neutral-100"
              onClick={() => navigate('/provision')}
            >
              <Settings className="h-5 w-5" />
            </button>
          )}
          <button
            type="button"
            aria-label="Sign out"
            className="rounded p-2 text-neutral-600 hover:bg-neutral-100"
            onClick={async () => {
              await useAuthStore.getState().signOut();
              navigate(effectiveGuardAuthMode() === 'user' ? '/login' : '/provision', { replace: true });
            }}
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </header>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
